<template>
  <div class="service-page">
    <img class="service-bg" :src="require('@/assets/icons/service.png')" alt="">
    <img class="service-qr" src="http://mmcb-pub-static.mmcb.top/service-qrcode.jpg" alt="">
  </div>
</template>
<script>
export default {
  name: 'service',
  data() {
    return {

    }
  }
}
</script>
<style lang="scss" scoped>
  .service-page{
    position: relative;
    min-height: 100vh;
    background: #feb67b;
  }
  .service-bg{
    width: 100%;
  }
  .service-qr{
    width: 100px;
    height: 100px;
    position: absolute;
    top: 436px;
    left: 80px;
  }
</style>
